exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fr-box.fr-basic.fr-top {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.fr-wrapper {\n  flex: 1 !important;\n}\n.fr-second-toolbar {\n  border: none !important;\n}", ""]);

// exports
